import React, { useRef, useEffect } from 'react'
import Icons from '../components/Icons'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'

const ReviewsSection = ({ onSectionChange, currentSection }) => {
  const reviewsSectionRef = useRef()

  const { t } = useTranslation()

  const handleScroll = (event) => {
    const scrollTop = reviewsSectionRef.current.getBoundingClientRect().bottom
    if (scrollTop <= 100 && currentSection === 'section5') {
      onSectionChange('section6')
    } else if (scrollTop > 100 && currentSection === 'section6') {
      onSectionChange('section5')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const reviews = [
    {
      name: 'Loïc R.',
      title: 'DevOps and automation architect @ Worldline',
      review: t('reviewsSection.reviews')[0],
      image: '/img/loic.jpg'
    },
    {
      name: 'Thibault D.',
      title: 'IT Team Manager @ Equens',
      review: t('reviewsSection.reviews')[1],
      image: '/img/thibault.jpg'
    },
    {
      name: 'Alexandre M.',
      title: 'CTO @ Participate',
      review: t('reviewsSection.reviews')[2],
      image: '/img/alexandre.jpg'
    }
  ]

  return (
    <section
      ref={reviewsSectionRef}
      id="section5"
      className="pt-10 relative bg-gray-100 w-full"
    >
      <div className="w-5/6 md:w-3/4 lg:w-4/6 mx-auto py-16">
      <Fade direction="up">
        <h2 className="title font-bold text-4xl text-martinique relative z-10">
            {t('reviewsSection.title')}
        </h2>
      </Fade>

        <CarouselProvider
          totalSlides={reviews.length}
          className="mt-16"
        >
          <Slider className="h-96">
          {reviews.map((value, index) => {
            return <Slide index={index} key={index} className="flex justify-start text-center pb-10 w-full flex-col">
            <img alt={ value.name } height="96" width="96" src={value.image} className="w-24 mx-auto rounded-full border-4 border-yellow-500" />
            <h3 className="font-bold font-lg pt-2">{ value.name }</h3>
            <span className="font-thin py-1 text-athens-gray-600">{ value.title }</span>
            <div className="rounded-3xl bg-white shadow-lg md:w-2/3 md:mx-auto font-thin text-martinique mx-5 p-5 mt-7 flex justify-center content-center items-center relative arrow-top">
              <p>{ value.review }</p>
            </div>
          </Slide>
          })
          }
          </Slider>
          <DotGroup className="text-center" />
        </CarouselProvider>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-42 gap-y-14 self-center place-items-center place-content-center mt-10">
            <Icons name="phoenix" className="w-24 h-20 bw" />
            <Icons name="elixir" className="w-40 h-32 bw" />
            <Icons name="ruby" className="w-24  h-16 bw" />
            <Icons name="rails" className="w-32 h-16 bw" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 md:mx-12 gap-x-10 gap-y-14 self-center place-items-center place-content-center mt-10">
            <Icons name="nodejs" className="w-28  h-24 bw" />
            <Icons name="vue" className="w-36 h-32 bw"/>
            <Icons name="flutter" className="w-32 h-32 bw" />
        </div>
      </div>
    </section>
  )
}

export default ReviewsSection
